import { endSession } from '../api/api';

const NHS_LOGOUT_URL = 'https://fs.nhs.net/adfs/oauth2/logout';

/**
 * Ends the session in all three places it exists: this browser, our backend
 * and NHS. The local session is gone by the time this returns, so callers
 * that only want the user signed out can ignore the promise.
 */
function logout(): Promise<void> {
  const token = window.sessionStorage.getItem('jwtToken');
  const serverSessionEnded = token ? endSession(token) : Promise.resolve();

  window.sessionStorage.removeItem('jwtToken');
  window.localStorage.removeItem('userId');
  window.open(NHS_LOGOUT_URL, '_blank');

  return serverSessionEnded;
}

export default logout;
